import { isEqual } from 'lodash';

export default {
  name: 'FormComponentMixin',
  props: {
    modelValue: {
      type: Object,
      default() {
        return null;
      }
    },
    name: {
      type: String,
      default() {
        return null;
      }
    },
    disabled: {
      type: Boolean,
      default() {
        return false;
      }
    }
  },
  data() {
    return {
      model: null
    };
  },
  computed: {
    loading() {
      return this.$store.state.policy.loading;
    }
  },
  mounted() {
    this.model = this.modelValue;
  },
  watch: {
    modelValue(val) {
      this.model = val;
    }
  },
  methods: {
    validateField(value) {
      this.$emit('update:modelValue', value);

      this.$validator.validate(this.name).then((result) => {
        if (!result) {
          return (this.disabled = true);
        }

        return (this.disabled = false);
      });
    },
    isSelected(option) {
      return isEqual(option, this.modelValue).toString();
    }
  }
};
